import React from 'react';

const IconActiveCheck = ({ color }) => (
    <svg width='20' height='21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M16.667 5.5 7.5 14.667 3.333 10.5' stroke='#fff' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
);

export default IconActiveCheck;
